import { zeroAddress } from "viem"
import { ProductCart, useEthUsd } from "."
import { useSliceContext } from "../components/SliceProvider"
import { utils } from "ethers"

export const useProductParams = (product: ProductCart) => {
  const { appChainId, cart, updateCart } = useSliceContext()
  const ethUsd = useEthUsd(appChainId)

  const {
    slicerAddress,
    productId,
    quantity,
    price,
    currency,
    isUSD,
    extCallValue,
    basePrice
  } = product

  const productPrice = isUSD
    ? Math.floor(Number(price) / (ethUsd * 100)) / 10000
    : currency === zeroAddress
    ? Math.floor(Number(price) / 10 ** 14) / 10000
    : Math.floor(Number(price) / 10 ** 4) / 100
  const externalCallEth = utils.formatEther(extCallValue)
  const index = cart.findIndex(
    (p: ProductCart) =>
      p.productId == productId && p.slicerAddress == slicerAddress
  )
  const handleRemove = () => {
    const newCart = [...cart]
    newCart.splice(index, 1)
    updateCart(newCart)
  }

  const decimals = currency === zeroAddress ? 4 : 2
  const formattedPrice =
    Math.floor(
      (Number(productPrice) + Number(externalCallEth)) * 10 ** decimals
    ) /
    10 ** decimals
  const symbol = currency === zeroAddress ? "ETH" : "USDC"

  const unitPrice = BigInt(price) / BigInt(quantity)

  const fullPrice = isUSD
    ? Math.floor((quantity * Number(basePrice)) / (ethUsd * 100)) / 10000
    : currency === zeroAddress
    ? Math.floor((quantity * Number(basePrice)) / 10 ** 14) / 10000
    : Math.floor((quantity * Number(basePrice)) / 10 ** 4) / 100

  const formattedFullPrice =
    Math.floor((Number(fullPrice) + Number(externalCallEth)) * 10 ** decimals) /
    10 ** decimals

  const isDiscounted = BigInt(basePrice) > unitPrice
  const displayedPrice =
    formattedPrice != 0 ? `${symbol} ${formattedPrice}` : "Free"
  const displayedFullPrice = `${symbol} ${formattedFullPrice}`

  return {
    displayedPrice,
    displayedFullPrice,
    handleRemove,
    isDiscounted
  }
}
